// extracted by mini-css-extract-plugin
module.exports = {"bar":"SwitchBar_bar__2YCIi","bar__item":"SwitchBar_bar__item__2DVh7","bar__item_active":"SwitchBar_bar__item_active__12OIc"};